/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RequestedRepairOrder,
} from '../models';
import {
    RequestedRepairOrderFromJSON,
    RequestedRepairOrderToJSON,
} from '../models';

export interface GetRequestedRepairOrdersRequest {
    customerId: string;
    xPcsImpersonatedUser?: string;
}

/**
 * 
 */
export class RequestedRepairOrdersApi extends runtime.BaseAPI {

    /**
     * Get a list of Requested Repair Orders
     * Get Requested Repair Orders
     */
    async getRequestedRepairOrdersRaw(requestParameters: GetRequestedRepairOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RequestedRepairOrder>>> {
        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getRequestedRepairOrders.');
        }

        const queryParameters: any = {};

        if (requestParameters.customerId !== undefined) {
            queryParameters['customerId'] = requestParameters.customerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xPcsImpersonatedUser !== undefined && requestParameters.xPcsImpersonatedUser !== null) {
            headerParameters['x-pcs-impersonated-user'] = String(requestParameters.xPcsImpersonatedUser);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-ms-client-principal"] = this.configuration.apiKey("x-ms-client-principal"); // api-security authentication
        }

        const response = await this.request({
            path: `/repairOrder/requests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RequestedRepairOrderFromJSON));
    }

    /**
     * Get a list of Requested Repair Orders
     * Get Requested Repair Orders
     */
    async getRequestedRepairOrders(requestParameters: GetRequestedRepairOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RequestedRepairOrder>> {
        const response = await this.getRequestedRepairOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
